import React, { Fragment, useState } from "react";
import { GoPlus } from "react-icons/go";
import { Button } from "../../../components/forms";
import AddContactModal from "../../../components/Modules/CRM/AddContactModal";
import { Menu, Transition } from "@headlessui/react";
import { LuMoreVertical } from "react-icons/lu";
import { IoChevronDownOutline } from "react-icons/io5";
import ContactItem from "../../../components/Modules/CRM/ContactItem";
import { useQuery } from "@tanstack/react-query";
import { onGetOrgContacts } from "../../../services/crm/contacts";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import Spinner from "../../../components/generic/Spinner";

function CRMContacts() {
  const [addshowcontact, setshowaddcontact] = useState(false);

  const { config , SelectedOrg} = useStateGetter();
  const { data, isPending, error } = useQuery({
    queryKey: ["contacts_list"],staleTime: 0,
     queryFn: () => onGetOrgContacts(SelectedOrg.id, config),
  });


  return (
    <div className="w-full pr-10  flex  ">
      <Spinner loading ={isPending}/>
      {addshowcontact && <AddContactModal isedit={false} show={setshowaddcontact} />}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="flex items-center justify-between">
          <p className="font-[600]">Contacts</p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Contact
              </>
            }
            onBtnClick={() => {
              setshowaddcontact(true);
            }}
          />
        </div>

        <div className="flex gap-4 ">
          <ActionBtn title={"All type"} />
          <ActionBtn title={"All priority"} />
        </div>

        <div className="   w-full gap-4 mt-3  grid grid-cols-3">
         {data?.data?.map((lk:any)=><ContactItem item={lk} />)} 
           
        </div>
      </div>
    </div>
  );
}

export default CRMContacts;

const ActionBtn = ({ title }) => (
  <Menu as="div" className="  self-center  relative  ">
    <div>
      <Menu.Button className="   p-1 flex text-sm rounded-full ">
        <div className=" text-xs flex cursor-pointer gap-2 text-gray-500 border-2 p-2 border-gray-500 rounded-lg">
          {title} <IoChevronDownOutline />
        </div>
      </Menu.Button>
    </div>
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items className=" absolute right-0 mt-2 w-48 rounded-[8px] shadow-md p-1 bg-white ring-1   focus:outline-none">
        <Menu.Item>
          <p
            onClick={async () => {}}
            className="text-semibold text-textbg text-sm cursor-pointer p-2 hover:bg-gray-100 "
          >
            {title}
          </p>
        </Menu.Item>
      </Menu.Items>
    </Transition>
  </Menu>
);
